(function () {
    'use strict';

    /* @ngdoc object
     * @name home
     * @description
     *
     */
    angular
        .module('welcome', [
            'ui.router'
        ]);
}());